__turbopack_context__.v({
  "bene": "style-module-scss-module__kx20SG__bene",
  "benes": "style-module-scss-module__kx20SG__benes",
  "icon": "style-module-scss-module__kx20SG__icon",
  "label": "style-module-scss-module__kx20SG__label",
});
